import React, { createContext } from 'react';
import {TokenManager} from "../../services/TokenManager";
import {User} from "../../models/User";
import {ToastParam} from "../ui-components/toast/UiToast";

interface AppContextType {
    isConnected: boolean;
    setIsConnected: React.Dispatch <React.SetStateAction<boolean>>;
    currentUser: User | null
    setUser: React.Dispatch<React.SetStateAction<User | null>>,
    openToastWithParams: (toastParam: ToastParam) => void,
    errorToast: () => void,
}

const AppCo: AppContextType = {
    isConnected: TokenManager.getToken() !== "",
    setIsConnected: () => {},
    currentUser: null,
    setUser: () => {},
    openToastWithParams: (toastParam: ToastParam) => {},
    errorToast: () => {},
};

export const AppContext = createContext<AppContextType>(AppCo);

type AppContextProviderProps = {
    children: React.ReactNode,
    isConnected: boolean,
    setIsConnected: React.Dispatch<React.SetStateAction<boolean>>,
    user: User | null,
    setUser: React.Dispatch<React.SetStateAction<User | null>>,
    openToastWithParams: (toastParam: ToastParam) => void,
    errorToast: () => void,
}

export const AppContextProvider: React.FC<AppContextProviderProps> = ({
    children,
    isConnected,
    setIsConnected,
    user,
    setUser,
    openToastWithParams,
    errorToast
}) => {
    return (
        <AppContext.Provider value={{
            isConnected, setIsConnected, currentUser: user, setUser, openToastWithParams, errorToast
        }}>
            {children}
        </AppContext.Provider>
    );
};
